var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticClass: "wp-10",
      attrs: {
        filterable: "",
        multiple: "",
        "multiple-limit": _vm.parameters.number_of_values,
        remote: "",
        placeholder: _vm.$t.__("common.actions.search"),
        "remote-method": _vm.remoteMethod,
        loading: _vm.loading
      },
      model: {
        value: _vm.localValue,
        callback: function($$v) {
          _vm.localValue = $$v
        },
        expression: "localValue"
      }
    },
    _vm._l(_vm.options, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.fullName, value: parseInt(item.id) }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }